import React, { useState, Fragment } from "react";
import clsx from "clsx";
import { setActiveTorrent } from "../../actions";
import { Drawer, Tabs, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { red } from "@material-ui/core/colors";
import { TorrentStatus, Torrent } from "../../types";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../reducers";
import General from "./General";
import Files from "./Files";
import Trackers from "./Trackers";
import {
  thunkFetchTorrentFiles,
  thunkFetchTorrentTrackers
} from "../../thunks";

const useStyles = makeStyles(theme => ({
  grow: {
    flexGrow: 1
  },
  tabPanel: {
    width: 600,
    margin: theme.spacing(2),
    display: "flex",
    flexDirection: "column"
  },
  tabContent: {
    margin: theme.spacing(3),
    boxSizing: "border-box",
    fontSize: "0.875rem"
  },
  title: {
    "& *": {
      fontSize: 22,
      fontWeight: "bolder"
    }
  },
  buttons: {
    "& > *": {
      margin: theme.spacing(1)
    },
    textAlign: "center"
  },
  rowLabel: {},
  error: {
    color: red[400]
  }
}));

export default function Detail() {
  const classes = useStyles();
  const [tab, setTab] = useState("general");
  const dispatch = useDispatch();
  const active = useSelector(
    (state: RootState) => state.torrent.active
  ) as Partial<Torrent> & { id: number; hash: string };
  const handleDrawerClose = () => {
    setTab("general");
    dispatch(setActiveTorrent());
  };
  const handleFilesTabClick = () => {
    if (!active.files) {
      dispatch(thunkFetchTorrentFiles(active.id, active.hash));
    }
  };

  const handleTrackersTabClick = () => {
    if (!active.files) {
      dispatch(thunkFetchTorrentTrackers(active.id, active.hash));
    }
  };

  return (
    <Drawer
      anchor="right"
      open={!!active}
      onClose={handleDrawerClose}
      transitionDuration={400}
    >
      {!!active && (
        <Fragment>
          <Tabs
            value={tab}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            onChange={(e, newTab) => setTab(newTab)}
          >
            <Tab label="General" value="general" />
            <Tab
              label="Files"
              value="files"
              disabled={active.status !== TorrentStatus.PUSHED}
              onClick={handleFilesTabClick}
            />
            <Tab
              label="Trackers"
              value="trackers"
              disabled={active.status !== TorrentStatus.PUSHED}
              onClick={handleTrackersTabClick}
            />
          </Tabs>
          <div className={clsx(classes.tabPanel, classes.grow)}>
            {tab === "general" && <General classes={classes} />}
            {tab === "files" && <Files />}
            {tab === "trackers" && <Trackers />}
          </div>
        </Fragment>
      )}
    </Drawer>
  );
}
